export default Object.freeze({
  NoMatch: 1,
  MatchedDeny: 2,
  MatchedAllow: 3,
});
